import { ClientError } from "graphql-request";

import type { GrpcStatusCode } from "@/utils/errors/types";
import { GRPC_STATUS_CODES } from "@/utils/errors/types";

const KNOWN_GRPC_CODES = new Set<number>(Object.values(GRPC_STATUS_CODES));

const isGrpcStatusCode = (value: unknown): value is GrpcStatusCode =>
  typeof value === "number" && KNOWN_GRPC_CODES.has(value);

const isObjectWithCode = (value: unknown): value is { code: unknown } =>
  typeof value === "object" && value !== null && "code" in value;

export const getGrpcErrorCode = (error: unknown): GrpcStatusCode | null => {
  if (!(error instanceof ClientError)) {
    return null;
  }

  const extensions = error.response.errors?.[0]?.extensions;

  if (!extensions) {
    return null;
  }

  const response = extensions["response"];

  if (!isObjectWithCode(response)) {
    return null;
  }

  return isGrpcStatusCode(response.code) ? response.code : null;
};
